import { render } from "./InstallApp.vue?vue&type=template&id=168fb24b&scoped=true"
import script from "./InstallApp.vue?vue&type=script&lang=js"
export * from "./InstallApp.vue?vue&type=script&lang=js"

import "./InstallApp.vue?vue&type=style&index=0&id=168fb24b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168fb24b"]])

export default __exports__